"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteApi = deleteApi;
exports.getActiveCustomersApi = getActiveCustomersApi;
exports.getBrandrApi = getBrandrApi;
exports.getGoodsList = getGoodsList;
exports.getSupplierApi = getSupplierApi;
exports.infoApi = infoApi;
exports.listApi = listApi;
exports.saveApi = saveApi;
exports.updateApi = updateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 分页列表
 */
function listApi(params) {
  return (0, _request.default)({
    url: "/admin/store/update-info/list",
    method: 'GET',
    params: params
  });
}

/**
 * 详情
 */
function deleteApi(params) {
  return (0, _request.default)({
    url: "/admin/store/update-info/delete",
    method: 'GET',
    params: params
  });
}

/**
 * 详情
 */
function infoApi(params) {
  return (0, _request.default)({
    url: "/admin/store/update-info/info",
    method: 'GET',
    params: params
  });
}

/**
 * 修改
 */
function updateApi(data) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _request.default)({
    url: "/admin/store/update-info/update",
    method: 'POST',
    data: data,
    params: params
  });
}

/**
 * 新增
 */
function saveApi(data) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _request.default)({
    url: "/admin/store/update-info/save",
    method: 'POST',
    data: data,
    params: params
  });
}

// 获取商品列表
function getGoodsList(params) {
  // return request({
  //     url: '/admin/store/sku/list',
  //     method: 'GET',
  //     params,
  // });

  return (0, _requestMapi.default)({
    url: '/mapi/product/store/sku/list',
    method: 'GET',
    params: params
  });
}

/**
 * 品牌 keyword
 */
function getBrandrApi(params) {
  return (0, _request.default)({
    url: "/admin/pay/component/shop/brand/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 供应商
 */
function getSupplierApi(params) {
  // return request({
  //     url: `/admin/business/supplier/autoList`,
  //     method: 'GET',
  //     params,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/supplier/autoList',
    method: 'GET',
    params: params
  });
}

/**
 * 获取商户
 */
function getActiveCustomersApi() {
  // return request({
  //     url: `/admin/customers/active-customers`,
  //     method: 'GET',
  // });

  return (0, _requestMapi.default)({
    url: "/mapi/user/customer/active-customers",
    method: 'GET'
  });
}